import React, { Component } from 'react';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { Solicitud_actividad } from './expand/Solicitud_actividad';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Col, Row, Container } from 'react-bootstrap';
import crear from './../img/svg/Nueva.svg';
import enviar from './../img/svg/Enviar(blanco).svg';

const API_URL = process.env.REACT_APP_API_URL;
function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
}
function color_head_desc(tipo) {
    if (tipo === 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo === 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo === 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '15%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}

function desgloseHoras(termino, periodicidad, numhoras, totalhoras) {
    if (periodicidad !== "ANUAL") {
        if (termino === "1") {
            return periodicidad === "SEMESTRAL" ? numhoras : numhoras * 20;

        } else if (termino === "2") {
            return periodicidad === "SEMESTRAL" ? numhoras : numhoras * 20;

        } else if (termino === "0") {
            return periodicidad === "SEMESTRAL" ? numhoras : numhoras * 8;
        }
    } else {
        return totalhoras;
    }
}
 
export class Vinculacion_out extends Component {
    static displayName = Vinculacion_out.name;

    handleBtnClick = () => {
        if (!this.state.expanded.includes(0)) {
            this.setState(() => ({
                expanded: [...this.state.expanded, 0]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded: [...this.state.expanded, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== row.id)
            }));
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], solicitudes: [], busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            },
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ], loading: false, loading2: false, loading3: false, expanded: [], total: 0,
            anio: props.anio, idpersona: props.idprof, actividades_combo: []
            , periodo: "", newactividad: "", observacion: "",
            nuevoregistro: [], selectact: "", selectidact: "", abierto: false, fila: []
        };

        this.onChangePao = this.onChangePao.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleNew = this.handleNew.bind(this);

        this.updatestate = this.updatestate.bind(this);
    }

    componentDidMount() {
        if (this.state.idpersona > 0) {
            this.populateActividadesData(this.state.idpersona, this.state.anio);
            this.populateActividadesCombo(this.state.idpersona, this.state.anio);
        }
    }

    get_radios(termino1, termino2, termino3, anio) {
        var respu;
        if (termino2 === "2" && termino1 === "1" && termino3 === "0") {
            return (
                <><span className="label label-success">  PAE {anio}</span><br /><span className="label label-success"> PAO {anio}-1</span><br /><span className="label label-success">  PAO {anio}-2</span></>
            )
        }
        else if (termino1 === "1") {
            if (termino1 === "1" && termino3 === "0") {
                return (
                    <><span className="label label-success"> PAO {anio}-1</span><br /><span className="label label-success">  PAE {anio}</span></>
                );
            } else if (termino2 === "2" && termino1 === "1") {
                return (
                    <><span className="label label-success"> PAO {anio}-1</span><br /><span className="label label-success">  PAO {anio}-2</span></>
                );
            } else {
                return (
                    <span className="label label-success"> PAO {anio}-1</span>
                );
            }
        } else if (termino2 === "2") {
            if (termino2 === "2" && termino1 === "1") {
                return (
                    <><span className="label label-success"> PAO {anio}-1</span><br /><span className="label label-success">  PAO {anio}-2</span></>
                );

            } else if (termino2 === "2" && termino3 === "0") {
                return (
                    <><span className="label label-success"> PAO {anio}-2</span><br /><span className="label label-success">  PAE {anio}</span></>
                );
            }
            return (
                <span className="label label-success">  PAO {anio}-2</span>
            );
        } else if (termino3 === "0") {
            if (termino3 === "0" && termino1 === "1") {
                return (
                    <><span className="label label-success"> PAE {anio}</span><br /><span className="label label-success">  PAO {anio}-1</span></>
                );

            } else if (termino3 === "0" && termino2 === "2") {
                return (
                    <><span className="label label-success"> PAE {anio}</span><br /><span className="label label-success">  PAO {anio}-2</span></>
                );
            }
            return (
                <span className="label label-success">  PAE {anio}</span>
            );
        }
    }

    updatestate(idactividad, descripcion, totalhoras, anio, terminos, tipoactividad, observacion, pao1, pao2, pae, accion) {
        //const terminos = this.get_radios(pao1, pao2, pae, anio)
        
        var solicitudes = this.state.solicitudes
        if (solicitudes.length == 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad != idactividad)
        }

        solicitudes.push({
            idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: terminos, tipoactividad: tipoactividad, pao1: pao1, pao2: pao2, pae: pae, accion: accion
        })
        this.setState({
            solicitudes: solicitudes
        });

        this.props.update({
            ambito: 'A|V', idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: terminos, tipoactividad: tipoactividad, pao1: pao1, pao2: pao2, pae: pae, accion: accion
        });

    }

    handleHideClick = (idactividad) => {
        let obj = this.state.fila.find((o, i) => {
            if (o.idactividad === idactividad) {
                this.state.fila[i].validacion = 'si'
                return this.state.fila[i];
            }
        });
        if (obj == null) {
            this.state.fila.push({
                idactividad: idactividad,
                validacion: 'si'
            })
        }
        if (this.state.expanded.includes(idactividad)) {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== idactividad)
            }));
        }
        //console.log(this.state.fila);

    }

    handleShowClick = (idactividad) => {


        //console.log(idactividad)
        if (!this.state.expanded.includes(idactividad)) {

            let obj = this.state.fila.find((o, i) => {
                if (o.idactividad === idactividad) {
                    this.state.fila[i].validacion = 'no'
                    return this.state.fila[i];
                }
            });
            if (obj == null) {
                this.state.fila.push({
                    idactividad: idactividad,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded: [...this.state.expanded, idactividad]
            }));
        }
        //console.log(this.state.fila);
    }

    handleHideAllClick = () => {

        let filas = [];

        this.state.actividades.forEach((element) => {
            filas.push({
                idactividad: element.idactividad,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded: [],
            fila: filas
        }));
        //console.log(this.state.fila);
        this.handleAllCheck()
    }

    handleShowAllClick = () => {

        let filas = [];
        let expandir = [];
        this.state.actividades.forEach((element) => {
            filas.push({
                idactividad: element.idactividad,
                validacion: 'no'
            });
            if (!this.state.expanded.includes(element.idactividad)) {
                expandir.push(element.idactividad);
            }
        })
        this.setState(() => ({
            expanded: this.state.expanded.concat(expandir),
            fila: filas
        }));
        //console.log(this.state.fila);
        //console.log(this.state.actividades);
        this.handleAllCheck()
    }

    handleAllCheck() {
        //console.log(this.state.fila);
        const check = document.getElementsByName("all_vi");
        const checkSin = document.getElementById("Actividades_vi").getElementsByClassName('form-check-input');
        //console.log(check);
        //console.log(checkSin);
        if (check[0].checked) {
            //console.log('Siu');
            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "1") {
                    checkSin[i].checked = true;
                } else{
                    checkSin[i].checked = false;
                }
            }
        } else {

            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "0") {
                    //console.log('Nou');
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        }
    }
    renderActividadesTable(actividades) {
        //console.log("vinculacion_out: ", actividades);

        var actividades_split = [];

        actividades.map((act, index) => {
            if (act.termino3 === "0") {
                var thoras3 = desgloseHoras(act.termino3, act.periodicidad, act.numhoras, act.totalhoras);
                actividades_split.push({
                    "actividad": act.actividad,
                    "anio": act.anio,
                    "descripcion": act.descripcion,
                    "escarga": act.escarga,
                    "estadocheck": act.estadocheck,
                    "idactividad": act.idactividad,
                    "idUnico": act.idactividad + '0',
                    "idtipoactividad": act.idtipoactividad,
                    "nivelEstudio": act.nivelEstudio,
                    "numhoras": act.numhoras,
                    "periodicidad": act.periodicidad,
                    "termino1": null,
                    "termino2": null,
                    "termino3": act.termino3,
                    "tipoactividad": act.tipoactividad,
                    "totalhoras": act.horastermino3
                });
            }

            if (act.termino1 === "1") {
                var thoras1 = desgloseHoras(act.termino1, act.periodicidad, act.numhoras, act.totalhoras);
                actividades_split.push({
                    "actividad": act.actividad,
                    "anio": act.anio,
                    "descripcion": act.descripcion,
                    "escarga": act.escarga,
                    "estadocheck": act.estadocheck,
                    "idactividad": act.idactividad,
                    "idUnico": act.idactividad + '1',
                    "idtipoactividad": act.idtipoactividad,
                    "nivelEstudio": act.nivelEstudio,
                    "numhoras": act.numhoras,
                    "periodicidad": act.periodicidad,
                    "termino1": act.termino1,
                    "termino2": null,
                    "termino3": null,
                    "tipoactividad": act.tipoactividad,
                    "totalhoras": act.horastermino1
                });
            }

            if (act.termino2 === "2") {
                var thoras2 = desgloseHoras(act.termino2, act.periodicidad, act.numhoras, act.totalhoras);
                actividades_split.push({
                    "actividad": act.actividad,
                    "anio": act.anio,
                    "descripcion": act.descripcion,
                    "escarga": act.escarga,
                    "estadocheck": act.estadocheck,
                    "idactividad": act.idactividad,
                    "idUnico": act.idactividad + '2',
                    "idtipoactividad": act.idtipoactividad,
                    "nivelEstudio": act.nivelEstudio,
                    "numhoras": act.numhoras,
                    "periodicidad": act.periodicidad,
                    "termino1": null,
                    "termino2": act.termino2,
                    "termino3": null,
                    "tipoactividad": act.tipoactividad,
                    "totalhoras": act.horastermino2
                });
            }
        });

        const totalpepa = 0;
        const totalpepa2 = this.state.actividades ? this.state.actividades.map(horastot2 => horastot2.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const talambito = totalpepa + totalpepa2;

        const columns_acti = [{
            dataField: 'id',
            text: '#',

            footer: '',
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1}
                    </div>
                )
            }
        }, {
            dataField: 'idactividad',
            text: '#',
            hidden: true,
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'idUnico',
            text: 'ID UNICO',
            hidden: true
        }, {
            dataField: 'actividad',
            text: 'Actividad',
            headerStyle: color_head_desc('d'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'descripcion',
            text: 'Descripción',
            headerStyle: color_head_desc('a'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'termino1',
            text: 'Periodo',
            formatter: (cellContent, row) => {
                if (row.termino1 === "1") {
                    return <>PAO {row.anio}-1</>

                } else if (row.termino2 === "2") {
                    return <>PAO {row.anio}-2</>

                } else if (row.termino3 === "0") {
                    return <>PAE {row.anio}</>
                }
            },
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: 'Subtotal: '
        }, {
            dataField: 'totalhoras',
            text: 'Horas',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footerAlign: 'left',
            footer: () => {
                return (<>{talambito.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
            },


        }];

        return (
            <BootstrapTable
                id='Actividades_vi'
                keyField='idUnico'
                data={actividades_split}
                columns={columns_acti}
                bordered={false} 
            />

        );
    }

    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }


    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    handleChange(e) {
        var idactividad = e.target.value;
        var data = this.state.actividades_combo.filter(x => x.idactividad == idactividad).map(act => act.descripcion);

        this.setState({ selectact: data, selectidact: e.target.value });
    }

    handleSearch(event) {
        this.setState({ observacion: event.target.value });
        //console.log(this.state.observacion);
    }


    onChangePao(event) {
        this.setState({
            periodo: event.target.value
        })
        //console.log(this.state.periodo)
    }

    abrirModal = () => {
        this.setState({ abierto: !this.state.abierto });
    }

    cerrarModal = () => {
        this.setState({ abierto: false });
    }

    handleNew(e) {
        var termino = this.state.periodo
        this.updatestate(this.state.selectidact, this.state.selectact, '', this.props.anio, this.state.periodo, 'D', this.state.observacion, termino, termino, termino, 'Nueva Carga')

        //console.log('NUEVOOO' + this.state.selectidact + this.state.selectact + '' + this.props.anio + this.state.periodo + 'D' + this.state.observacion + termino + termino + termino + 'Nueva Carga')
        this.cerrarModal()
    }
    render() {

        let contents = this.state.loading
            ? <p><em>Loading...this.populateActividadesData(this.props.anio);</em></p>
            : this.renderActividadesTable(this.state.actividades);


        const totalpepa = 0;
        const totalpepa2 = this.state.actividades ? this.state.actividades.map(horastot2 => horastot2.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const talambito = (totalpepa + totalpepa2).toLocaleString('en', { maximumFractionDigits: 2 });

        const combo = {
            width: '150px',
        };
        const buttonToLink = {
            fontSize: '0.65em',
            textAlign: 'left',
            float: 'right',
            color: '#58A7E0',
            background: 'none',
            margin: 0,
            padding: 0,
            border: 'none',
            cursor: 'pointer',
            ":hover": {
                color: "yellow"
            }
        };
        const estilo = {
            color: 'white',
            fontSize: '15px',
            marginBottom: '20px',
            fontFamily: 'Robota'
        };

        const form_nuevo = {
            fontSize: '0.65em',
            color: "darkgray"
        };

        return (
            <div>
                    
                {contents}


                <div className="inline-grid  grid-cols-1 bg-total3">
                    <div className="px-1 ">Total de Ámbito de Vinculación: {talambito} horas</div>
                </div>

            </div>
        );
    }

    async populateActividadesData(idpersona, anio) {

        //const response = await fetch(API_URL + 'TblActividades/' + idpersona + '/' + anio + '/R/V');
        //const respuesta = await response.json();
        const respuesta = this.props.cargaAct;
        const data = respuesta;
        var selected = []
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idactividad: act.idactividad, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'AR', idactividad: act.idactividad, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino1 + '|' + act.termino2 + '|' + act.termino3 }) })
            data.map(act => { actividades.push({ ambito: 'V', idactividad: act.idactividad }) })
            var actividades2 = [];
            data.map(act => { actividades2.push({ tipo: 'A|V', idactividad: act.idactividad, anio: anio, descripcion: act.descripcion, periodo: act.termino1 + '|' + act.termino2 + '|' + act.termino3, accion: '', observacion: '', totalhoras: act.totalhoras,validado:1 }) })
            this.props.updateCarga(actividades, actividades2);
        }
        
        this.setState({ actividad_elegida: selected, actividades: data, loading: false });


    }

    async populateActividadesCombo(idpersona, anio) {
        const response = await fetch(API_URL + 'TblActividades/' + anio + '/V/token');
        const respuesta = await response.json();
        const data = respuesta;
        this.setState({ actividades_combo: data, loading: false });
    }

}
